/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Sodda Bulma modal — farm sahifalari uchun (tashqi bog'liqliksiz). */
import React from 'react'

export default function FarmModal({ title, isOpen, onClose, children, width = 520 }) {
    if (!isOpen) return null
    return (
        <div className="modal is-active">
            <div className="modal-background" onClick={onClose} />
            <div className="modal-card" style={{ maxWidth: width, width: '95%' }}>
                <header className="modal-card-head py-3">
                    <p className="modal-card-title is-size-5">{title}</p>
                    <button type="button" className="delete" aria-label="close" onClick={onClose} />
                </header>
                <section className="modal-card-body">
                    {children}
                </section>
            </div>
        </div>
    )
}
